import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { authAPI } from '../services/api';
import './Auth.css';

function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const login = useAuthStore(state => state.login);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const expired = searchParams.get('expired') === 'true';
  const oauthError = searchParams.get('error') === 'instagram_auth_failed'
    ? (searchParams.get('message') || 'Instagram authentication failed')
    : '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(formData);
      login(response.data.user, response.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleFacebookLogin = () => {
    authAPI.facebookLogin();
  };

  const handleInstagramLogin = () => {
    authAPI.instagramLogin();
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Brand Ambassador Platform</h1>
        <h2>Welcome Back</h2>
        
        {expired && (
          <div className="warning-message">Your session has expired. Please log in again.</div>
        )}
        
        {(error || oauthError) && <div className="error-message">{error || oauthError}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>
          
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
          </div>
          
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="divider">
          <span>or</span>
        </div>

        <button 
          type="button" 
          onClick={handleFacebookLogin} 
          className="btn-facebook"
        >
          <span className="fb-icon">f</span>
          Continue with Facebook
        </button>

        <button
          type="button"
          onClick={handleInstagramLogin}
          className="btn-instagram"
        >
          <span className="ig-icon">IG</span>
          Continue with Instagram
        </button>

        <p className="oauth-note">
          Instagram sign-in currently supports professional Instagram accounts.
        </p>
        
        <p className="auth-link">
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
        <p className="auth-link">
          Don't have an account? <Link to="/register">Register</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
